export const toValidCurrency = (currency: string): string => {
  if (currency === 'USDC' || currency === 'USDT') {
    return 'USD';
  }
  if (currency === 'MXNB') {
    return 'MXN';
  }
  if (currency === 'BRL1') {
    return 'BRL';
  }

  return currency;
};
